interface ModalContentProps {
    children: React.ReactNode;
}

export default function ModalContent({ children }: ModalContentProps) {
    return children;
}
